import { CommonServiceIds } from 'azure-devops-extension-api'
import { isFunction, isNil } from 'lodash'

import { getAzureService } from '@/utils/azure-devops-helpers/azure-service'

// Resolves to null when the host does not expose the page layout service.
// Not typed on purpose: the d.ts declares `setFullScreenMode(): void`, but the
// XDM proxy returns a promise that rejects on a host error, so it must be awaited.
const getAzurePageLayoutService = async () => {
  const service = await getAzureService(CommonServiceIds.HostPageLayoutService)

  if (
    isNil(service) ||
    !isFunction(service.setFullScreenMode) ||
    !isFunction(service.getFullScreenMode)
  ) {
    console.warn('Azure host page layout service is not available')
    return null
  }

  return service
}

/** @returns {Promise<boolean>} */
export const isAzureFullScreenSupported = async () => {
  const service = await getAzurePageLayoutService()

  return !isNil(service)
}

/** @returns {Promise<boolean>} false when the page layout service is not available */
export const getAzureFullScreenMode = async () => {
  const service = await getAzurePageLayoutService()

  if (!service) return false

  return Boolean(await service.getFullScreenMode())
}

/**
 * @param {boolean} enabled
 * @returns {Promise<boolean>} the host mode after the call;
 * false when the page layout service is not available
 */
export const setAzureFullScreenMode = async enabled => {
  const service = await getAzurePageLayoutService()

  if (!service) return false

  await service.setFullScreenMode(enabled)

  return await getAzureFullScreenMode()
}
